import React, { useState } from 'react';
import Modal from '../ui/Modal';
import { Button } from '../ui/button';

interface ComplianceReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (rejectionReason: string) => void;
  title: string;
  isLoading?: boolean;
}

const ComplianceReviewModal: React.FC<ComplianceReviewModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  isLoading = false,
}) => {
  const [rejectionReason, setRejectionReason] = useState('');

  const handleClose = () => {
    setRejectionReason('');
    onClose();
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    onConfirm(rejectionReason.trim());
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={title} maxWidth="md">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Rejection Reason
          </label>
          <textarea
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            rows={4}
            className="w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-sm"
            placeholder="Explain why this document was rejected"
            required
          />
        </div>
        <div className="flex justify-end gap-3">
          <Button type="button" variant="outline" onClick={handleClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button type="submit" variant="destructive" disabled={isLoading}>
            {isLoading ? 'Rejecting...' : 'Reject Document'}
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default ComplianceReviewModal;
